import { useState, useEffect } from "react";

function useDarkTheme() {
  const [darkMode, setDarkMode] = useState(false);
  useEffect(() => {
    const darkModeMediaQuery = window.matchMedia(
      "(prefers-color-scheme: dark)"
    );
    setDarkMode(darkModeMediaQuery.matches);
    darkModeMediaQuery.addListener((e) => {
      const darkModeOn = e.matches;
      setDarkMode(darkModeOn);
    });
  }, [darkMode]);
  return darkMode;
}

export default useDarkTheme;
